import React from "react";
import MuiFooter from "@material-ui/core/TableFooter";
import withStyles from "../../../styles/withStyles";

function Footer(props) {
  return <MuiFooter {...props} />;
}

let styles = theme => ({
  root: {
    borderTop: `2px solid ${theme.palette.secondary.main}`
  }
});

export default withStyles(styles)(Footer);
